export default {"src":"/_next/static/media/cross.f0306dad.svg","height":56,"width":56,"blurWidth":0,"blurHeight":0};